angular.module('MyApp')
.factory('Configs', ['Storage', 'EnvironmentEnum', function(Storage, EnvironmentEnum) {
  return {
    getApiServer: getApiServer,
    getEnvironment: getEnvironment
  }

  /*
   *  Retorna tipo de ambiente: DEV or PROD
   */
  function getEnvironment() {
    return EnvironmentEnum.DEV;
  }

  /*
   *  Retorna caminho relativo filtrado pelo proxy da API
   */
  function getApiServer() {
    return 'apix';
  }

}]);